import { render, staticRenderFns } from "./password-forgotten.vue?vue&type=template&id=6d795714&"
import script from "./password-forgotten.vue?vue&type=script&lang=js&"
export * from "./password-forgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports